export class CreateUserInput {
    'givenName';
    'email';
    'roleToProjectsMappings';
    'expiresAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleToProjectsMappings",
            "baseName": "roleToProjectsMappings",
            "type": "{ [key: string]: IDs; }",
            "format": ""
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateUserInput.attributeTypeMap;
    }
    constructor() {
    }
}
